export default __webpack_public_path__ + "static/media/green_tickmark.c9c2be5e.svg";